import { ReactNode } from 'react'

import { FormProvider, useForm } from 'react-hook-form'

import { IMultipleAutocompleteOption } from 'components/common/controller-wrapper'
import { SupplierActivationPeriod } from 'components/reports/Metrics/constants'
import { VehicleTypeFilter } from 'generated/graphql'

export interface DriverAppFulfilmentFilterValues {
  period: SupplierActivationPeriod
  customStart: Date | null
  customEnd: Date | null
  selectedServiceCodes: IMultipleAutocompleteOption[]
  vehicleType: VehicleTypeFilter
}

export const DRIVER_APP_FULFILMENT_DEFAULT_FILTERS: DriverAppFulfilmentFilterValues = {
  period: 'last90',
  customStart: null,
  customEnd: null,
  selectedServiceCodes: [],
  vehicleType: VehicleTypeFilter.All,
}

interface IProps {
  children: ReactNode
}

export const DriverAppFulfilmentFilterCriteria = ({ children }: IProps) => {
  const methods = useForm<DriverAppFulfilmentFilterValues>({
    defaultValues: DRIVER_APP_FULFILMENT_DEFAULT_FILTERS,
  })

  return <FormProvider {...methods}>{children}</FormProvider>
}
